import React from "react";
import { Container, Input, Label } from "../../Styles/Global.Styled";
import styled, { css } from "styled-components";

const SliderInput = styled.input`
  appearance: none;
  -webkit-appearance: none;
  width: 97.5%;
  /* margin: 10px 0; */
  position: absolute;
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    border: 0.25vh solid rgba(255, 255, 255, 1);
    width: 1.4vh;
    height: 1.4vh;
    background: ${({ thumbColor, theme }) => thumbColor || theme.main};
    border-radius: 50%;
    cursor: grabbing;
    position: relative;
    z-index: 2;
  }
`;
const cntStyle = css`
  flex-direction: column;
  gap: 0.5vh;
`;
const sliderCntStyle = css`
  height: 2vh;
  justify-content: center;
  align-items: center;
`;
const overlayStyle1 = (minPos, maxPos) => css`
  position: absolute;
  height: 1.5vh;
  background-color: ${({ theme }) => theme.main};
  width: ${`${maxPos - minPos}%`};
  left: ${`${minPos + 1}%`};
  border-radius: 50px;
  z-index: 1;
`;
const overlayStyle2 = css`
  position: absolute;
  height: 1.5vh;
  background-color: ${({ theme }) => theme.shadowColor};
  border: 1px solid;
  border-radius: 50px;
  width: 98%;
`;
const inputsCntStyle = css`
  gap: 1vh;
  justify-content: space-evenly;
`;
const inputCntStyle = css`
  height: 4vh;
  gap: 0.5vh;
`;
const inputStyle = css`
  border-radius: 6px;
  text-align: center;
`;
const labelStyle = css`
  position: absolute;
  right: 0.3vw;
  bottom: -0.5vh;
  font-size: 0.9vh;
  background-color: white;
  z-index: 2;
`;

const RangeSlider = ({ min, max, minValue, maxValue, step, handleChange }) => {
  const minPos = ((minValue - 0) / (max - 0)) * 98;
  const maxPos = ((maxValue - 0) / (max - 0)) * 98;

  return (
    <Container $baseStyle={cntStyle}>
      <Container $baseStyle={sliderCntStyle}>
        <SliderInput
          type="range"
          min={min}
          max={max}
          step={step}
          value={minValue}
          id="min"
          onChange={handleChange}
        />
        <SliderInput
          type="range"
          id="max"
          min={min}
          max={max}
          step={step}
          value={maxValue}
          onChange={handleChange}
        />
        <Container $baseStyle={overlayStyle1(minPos, maxPos)} />
        <Container $baseStyle={overlayStyle2} />
      </Container>
      <Container $baseStyle={inputsCntStyle}>
        <Container $baseStyle={inputCntStyle}>
          <Label>From</Label>
          <Input
            $baseStyle={inputStyle}
            size={1}
            id="min"
            value={minValue}
            onChange={handleChange}
          />
          <Label $baseStyle={labelStyle}>CM</Label>
        </Container>
        <Container $baseStyle={inputCntStyle}>
          <Label>To</Label>
          <Input
            $baseStyle={inputStyle}
            size={1}
            id="max"
            value={maxValue}
            onChange={handleChange}
          />
          <Label $baseStyle={labelStyle}>CM</Label>
        </Container>
      </Container>
    </Container>
  );
};

export default RangeSlider;
